var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('div',[_c('div',{staticClass:"panel info info-block mbl italic"},[_vm._v(" This tool is no longer in use. ")])])])}]

export { render, staticRenderFns }